module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("TOLLY HOPED")]), _vm._v(" it was not disgust he saw filling Leigh’s face. He understood that it must be a shock. Humans did not believe in Tolly’s kind anymore, or much of any magic, but surely Leigh felt their connection, that Tolly meant him no harm and only wanted to be….")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Well.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Loved.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But he could not tell Leigh that. The magic of the Breath of Life prevented it. He could tell Leigh that he was his. He could ask to stay with him. He could try to court him the way he had never attempted with any of his kin—he stayed away from other merfolk and was lucky he was such a fast swimmer and had never been caught—but he could not tell Leigh plainly that the only way he could keep his legs for longer than the next full moon was if his pact-bearer, the one who had given him legs, offered him a vow of love.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He also could not tell Leigh that if that did not happen, he would be put to death when the spell broke and the others came for him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Some of his fellows would jump at the chance to pursue him for that purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Holy shit,” Leigh said, more stunned than horrified, Tolly hoped.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You are welcome to touch it if you like,” he said with a light flick of his tailfin, just enough to fan it out, not to splash any water. Maybe that was too forward, but Tolly could not remember a time when anyone caressed his tail in kindness, and Leigh had such exquisite hands.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh’s eyes widened, wonder overtaking him the way magic often affected humans, but he shifted a small step closer to look on Tolly fully.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("His tail was not the most impressive, but Tolly had always been fond of his colors. Deep red and gold made him sparkle in the right light. Leigh said his human form was pleasing. He hoped his tail was, too, even if Leigh did find it strange at first.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("This version of himself was much lovelier than his true form.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("More than anything, more than his own life, Tolly did not want the pact to break and for Leigh to recoil when he saw what he truly looked like beneath the spell. He did not want Leigh to think of him as ugly or monstrous. The illusion was better.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh reached out, but before his fingers could touch the edge of Tolly’s tail, it gave another unconscious flick, and Leigh flinched like he had blinked awake from a gripping dream.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m losing my mind,” he said as he backed toward the door, then turned to escape the room entirely.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Leigh….” Tolly tried not to let his heart sink as deeply as it wanted to. If Leigh shunned him now, all would be lost. But he knew Leigh had to be the one. His kin might call him a hapless dreamer for wanting anything more than cruel fun at a human’s expense, but he thought the old legends beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The stories said that if one of his kin found the right human, the one destined for them, they would feel it, know it, and be drawn to save them from a watery grave. A single kiss was all it took to seal the pact, the Breath of Life connecting them as it gave the human the ability to breathe once more and sealed their fates together.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Afterward, if the merfolk chose to step out of the water, they would find themselves on legs, unsteady but surer with every step. They needed only to follow their human and woo them to love them, and together they could live happily on land or sea.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly wanted that so badly, he could barely stand the thought of one more day alone in the depths.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He did not need to be dry to recall his legs, but it still took him a moment to change back and stagger onto his feet to find a towel as Leigh had suggested so he would not drip water all over Leigh’s home. Humans preferred things dry usually.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Leigh!” he called as he wrapped the towel around his waist and hurried into the main room.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He did not see Leigh at first and panic overtook him as he feared the man had fled, but then he saw him standing out on the—what was it called?—fire escape! He had climbed out the window and stood outside gripping the railing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Not trusting himself to climb after him while encumbered by the towel, Tolly pleaded through the window. “Do you find me so terrible? So startling? I do not need to call out my tail. I can be human for you. I only wished for you to believe me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I believe you. I don’t think you’re crazy. Or that I am. Or that I’m dead. Dammit, don’t be dead….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You are very much alive, I promise you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Because you saved me.” Leigh turned around. “A mermaid saved me. Mer"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("man")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Folk,” Tolly corrected with a smile. “Though I do not mind anything you wish to call me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("With a sigh like finally catching his breath, Leigh came back in through the window, and Tolly backed up to give him room. “You aren’t terrible. Startling maybe. Your tail is gorgeous. It’s the fact that you have one that I’m having trouble with.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was so handsome. Tolly loved the way humans looked. He loved the way Leigh looked especially—tan skin, shorn hair, intense and hypnotizing blue eyes like the iciest parts of the ocean. He also loved how Leigh looked at him, curious and unsure but not unkind.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You may ask me anything you like,” Tolly said. But oh! He should not have said that. He could not truly answer "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("anything")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What happened to your… I mean…. When your tail is out, you’re smooth down there like a fish, like… there’s nothing….” He gestured vaguely in front of himself below the waist.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Oh")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Your sex is always in the open if not clothed. Ours is concealed unless we are using it. Would you like me to show you—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("No")]), _vm._v(",” Leigh said before Tolly could undo his towel. “That’s fine. I don’t know if I could handle that right now.” He took another deep breath and nodded. “You’re a merman.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And you want to stay with me because you saved my life, and doing that, for some reason, allows you to grow legs whenever you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes. I have nowhere else to go but back to the water. I do not wish to go back to the water. My kin are cruel to me. Vicious. I do not belong there. Please, do not cast me out—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey.” Leigh stepped forward and reached for him, but like before when he had been about to touch Tolly’s tail, he did not complete the act, as if it was not the sort of gesture he had ease finishing. “I’m not casting you out. You saved my life and this is somewhat… insanely… "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("cool")]), _vm._v(" that you even exist. Just a lot to take in.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Cool?” Tolly tried to recall the meaning of the word in this context.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Amazing. Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh.” Tolly smiled widely. “"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Cool")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But I am not someone anyone should want to stay with right now. Those men—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I will help you defeat them,” Tolly said surely. He knew cruelty was not only a trait of his people but existed broadly amongst humans as well. While he had no idea what it felt like to drown, it seemed a torturous thing to do to someone.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It isn’t a matter of defeating,” Leigh said. “This isn’t a battle. It’s more complicated than that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Then explain it to me, and I will help however I can.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No, I… I mean, it’s a long story and—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Rapid knocking startled them, rhythmic, like the beat of a song, very different from how Miss Maggie had knocked when she brought Tolly to Leigh’s door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She was a fine woman, Tolly had thought, just scolding at having encountered him undressed. He had not been able to find clothing between the river and Leigh’s home, though he knew it would be needed. His only goal had been reaching Leigh. Though admittedly, the pull to Leigh’s location had gotten confusing in a building where people stacked on top of one another, so he had been unsure of which floor was Leigh’s.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Miss Maggie had been quick to correct him when he went to her apartment instead.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Wait!” Leigh called at the continued knocking, familiar with its rhythm and who it belonged to, it seemed, but the person on the other side did not listen.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A young man entered, thin like Tolly though not as tall, smiling and friendly-looking with smatterings of bright color in his clothing, unlike Leigh’s monochrome.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey, what was Miss Maggie talking about down—” He stopped short when he saw Tolly and his smile shifted into something sly. “My, my. Who’s the twink?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Alvin")]), _vm._v(",” Leigh admonished, though Tolly was unacquainted with the word.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Just calling it like I see it. Good for you. No wonder you didn’t pick up the phone last night.” Alvin sauntered closer with a slow scan down Tolly’s body. He did not seem displeased with Tolly’s form either.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That isn’t what happened.” Leigh moved to intercept him. “Wait. You don’t "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("know")]), _vm._v(" what happened? You didn’t hear?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hear what?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Moretti gave me a dip in the river.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("What")]), _vm._v("?” The smile dropped from Alvin’s face as he focused on Leigh with a start.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Leo Moretti himself had three goons weight my ankles and drop me in to swim with the fishes.” Leigh paused with a glance at Tolly, and his eyes shone wide with sudden fear.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly might be slow with some things about the human world, but he was not a fool. “I was walking by the shore. I saw what happened and jumped in to save Leigh once the men had gone. I helped him home, and he allowed me to stay with him to get dry.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh’s distress instantly receded and he mouthed a silent “thank you.” Tolly would not reveal to anyone but Leigh what he truly was. He knew the dangers in that.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Since last night?” Alvin said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We fell asleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure ya did. A little victim and savior action?” His eyebrows bobbed, but his playfulness turned serious when he looked at Tolly. “You saved Leigh’s life, Stretch. I owe you one.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Stretch? My name is Tolly. Are you a friend of Leigh’s?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“His bestest. So I’m allowed to be both jealous and happy for him.” He winked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Nothing")]), _vm._v(" happened,” Leigh said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Plenty happened,” Alvin countered. “What are you gonna do about the Morettis? Does Dad know yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I was hoping to ask "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("you")]), _vm._v(" that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Alvin chewed his lip in thought, eyes darting between Leigh and Tolly. “You two stay put. I’ll do some recon and figure out where we stand. I’m sure Dad will know what to do, and this will all blow over in no time.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m sure "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Dad")]), _vm._v(" will be next in line to fit me with cement shoes if I don’t fix this myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Relax. We’ll figure it out. First, let me see who knows what. They must not know your address if no one’s here yet. You sit tight, buddy. And you sit pretty, Tinker Bell.” He winked at Tolly again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“My name is Tolly, not—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh he is adorable. Definitely a keeper.” Alvin scanned Tolly’s body like before. Then, when he turned to Leigh, he tapped him in the center of his chest in a subtle gesture of affection.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly was used to seeing hugs between humans to express such a thing, but Leigh did not seem comfortably physical in that way. Tolly had a feeling Alvin would have preferred to hug his friend, but he held back as a sign of respect and understanding. Tolly would have to remember that. After all, he would not like it if anyone was physical with him without permission either.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ll message you as soon as I know something. Be ready to move but take a breather, okay? Treat this fine specimen to breakfast,” Alvin said, scanning one more time along the towel Tolly wore before he turned on his heels.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was out the door as swiftly as he had entered, like a quickly moving storm, but Leigh seemed calmed after his appearance. Tolly decided that Alvin was welcome and would be his friend too.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He seems nice, ready to rally to your defense. But why does he not refer to me by name?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t worry about it. Just means he likes you. Now… clothes.” Leigh scanned Tolly’s body with far less hunger than Alvin had, more with uncertainty despite the glow in his cheeks. “Let me find you some.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly followed him into the bedroom. He was curious about beds and what it would be like to sleep on one. He had only ever floated or cushioned himself on sand. Usually he found dark, hidden places to rest. Leigh’s bed wasn’t overly large, but big enough for two, should Tolly be allowed to share it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh pulled out something blue for Tolly’s legs, white for his feet, black to go on before the blue—"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("underwear")]), _vm._v("—and red, a "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("sweater")]), _vm._v(" like the darkest parts of Tolly’s tail, for his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“There. You can, uhh…. Do you understand how to…?” Leigh trailed off when Tolly removed the towel and held it out to him. He thought it damp and perhaps rude to drop it on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes? I know where everything goes. I can dress myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Great. Good.” Leigh accepted the towel but kept his eyes skyward.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It really is all right to look at me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A shaky chuckle fell from Leigh’s lips and there was a brief, bashful flick of his eyes downward before he looked Tolly in the face. “Listen, that whole human decorum thing is important. You can’t act like this with other people.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I understand. I am yours alone. You need not worry.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And what does that mean exactly?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly thought of all the stories he knew of love and romance. Coming on “too strong” was often a negative. He needed to be clear to Leigh but not overwhelming. “It means that I hope the kiss I gave you in the water will not be our last.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The glow in Leigh’s cheeks darkened to a lovely shade. “I need to focus on one thing at a time. So you put those on, and I’ll see what I have for us to eat.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly nodded, but Leigh halted after only a step toward the door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What do merfolk… eat?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We are mostly carnivorous, but I am an omnivore like you. I can eat anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Bacon and eggs?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I would love to try that if it is what you wish to eat.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Okay.” Leigh seemed to want to glance down again to look at Tolly but refrained and promptly left the room.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly was not being shunned. He still had a chance to make this work. He would show Leigh how useful he could be, how well suited they were for each other, how happy he could make him. He started by putting on the clothing Leigh had given him. They were only slightly too large for him and seemed fine when he looked in the mirror on the closet door. He stood perhaps too long taking in his new form, but he liked it very much, even if the legs were an odd replacement for his tail.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When he ventured out of the bedroom, he found Leigh in the kitchen, from which wafted a wonderful smell as he cooked at the stovetop. “Cooked” was not something Tolly had experienced before either. Everything he ate was raw or still alive.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Bacon and eggs must taste delicious. It smells amazing.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah?” Leigh peered at him with a look of relief. “Good, coz I don’t have seafood in this place.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I also eat birds on occasion.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh froze. Perhaps that was a queer thing to say? Humans did not pursue prey the way merfolk did. “Well, uhh… you’ll probably like chicken, then.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly hovered in the doorway so he could watch Leigh. The movement of his hands and the fidget of his bare feet were mesmerizing. He had a vague vision through the connection of the Breath of Life of Leigh doing the same act as a boy—cooking in bare feet, alone.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh had no one either. Alvin, it seemed, and Miss Maggie, a few others perhaps, but he had no family. Tolly could feel it as keenly as he knew his own loneliness.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Here, why don’t you fill some glasses with water to put on the table and I’ll get this dished up?” Leigh said. “Glasses are in there, water from the tap.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Easy enough. Tolly was not used to drinking as humans did, but he was eager to learn everything Leigh could teach him. He followed the instructions, and when he returned, Leigh handed him two plates laden with food.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ll bring the forks. Do you know what a fork—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes. I am not the little mermaid.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You know about the little mermaid?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Of course.” Tolly preferred the colorful version with the singing. The ending was happier.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh. That’s good, I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They sat at the table in the corner of Leigh’s living room, and Tolly carefully picked up his fork. Knowing what something was and using it were two very different things. He watched Leigh for the right cues, how he used the fork to cut into the bacon, then speared a piece of egg with some of the yolk. Tolly copied the act and took his first bite.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Bliss")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh my. This "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("is")]), _vm._v(" wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh laughed. “Wait ’til you try something more complicated like Miss Maggie’s casserole.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I look forward to it.” Tolly dug into another bite.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("All too soon, Leigh seemed troubled again and asked, “About this whole you being mine thing….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I do not mean as a slave without my own will. If you wish it, I can be your… companion. Your partner. What is the word? Your "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("boyfriend")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh nearly choked on his next bite of food but chuckled in the aftermath of his coughing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly might be imagining what he wanted to see, but he thought Leigh looked at least a little smitten with him. He could not afford to make even a single misstep.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You said we’re connected because of how you saved me,” Leigh said. “That you know things about me, like my name and how to find me. Do you know… everything about me?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No. More a sense of you. But that is more than I need to know that I chose well.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The food was not yet gone from Leigh’s plate, but still he set his fork down. “Tolly, I need you to hear this. I am not a nice person. I wasn’t some innocent in need last night. Those men wanted me dead because I did bad things to them first.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What things?” Tolly set his fork down too.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Stole. I stole from them. I’m a criminal and a liar. Do you understand? I’m a bad man. I’m not some destiny for you to—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Another knock at the door interrupted him, this time causing Tolly to jump.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Who now?” Leigh grumbled. “Just hold on,” he said with a gesture for Tolly to stay seated, then rose to answer the door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly could not believe Leigh meant what he had said. Even if it was true, there had to be good reason for him to steal. Tolly would feel it if Leigh was a bad man. There had to be good in him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He watched Leigh peer through a tiny spyglass in the door before yanking it open.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ralph, what is it this time? I’ve had a long night. Shouldn’t you be on your way to school? I’m not awake enough for this.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was a boy, a teenager, nearly as tall as Leigh but whose face betrayed his age, and his voice cracked when he spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Come on, Hurley, it’s not that early. Heh. See how that rhymed?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Ralph")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s my laptop! If I lose this paper I gotta turn in today, I’m dead meat.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How many times do I have to say it? Computers aren’t my area.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But you always figure it out anyway, whether it’s a radio or a carburetor. Please? Just two seconds before I miss my bus.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh sighed, holding firm for as long as he could before he gestured the boy inside. He had a backpack over one shoulder and what Tolly believed was a laptop in his free hand, though he did not understand what one was used for exactly. The boy was quite skinny with angular features and a pointy nose.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh,” he said when he saw Tolly, then turned to Leigh with a snort. “"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Long night")]), _vm._v(", huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t even start. Now give me that.” Leigh snatched the laptop. “Ralph, this is Tolly. Tolly, Ralph.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hello.” Tolly smiled warmly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hi.” He tilted his head as if trying to read Tolly like a crooked signpost. “New runner?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You should not be asking questions like that,” Leigh snapped as he returned to the table and pushed his plate aside to make room for the laptop.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sorry. Just figured anybody you brought home would have to know you’re a… secret mobster,” he whispered far too loudly for Tolly not to overhear.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Not much of a secret with you around.” Leigh shook his head, fingers clacking away on the keys. Tolly had never seen a computer in person. He wondered what Leigh was doing to it, but he focused instead on the word.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Mobster")]), _vm._v(". It was true, then, but surely Leigh’s profession was function more than form.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ralph, do you know Leigh well?” Tolly asked the boy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I guess so. He’s lived in this building since I was a kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Still are, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("kid")]), _vm._v(",” Leigh said without looking up from his work.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Do you think he is a bad man?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Him? No way.” Ralph made an exaggerated expression. “He acts tough but he’s a big softie. Ain’t ya, Hurley?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh sighed again but did not respond.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I thought as much,” Tolly said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ralph…. First off, update your OS more than once every two years.” Leigh turned the laptop around, which appeared to be showing a string of text that Tolly assumed was the “paper” Ralph had been concerned about. “And stop Googling porn sites. Stick to the safe ones I told you about if you have to be hormonal.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ralph gave a jubilant cry as he collected his laptop. “You are the master, man. And yep, pretty sure as an exceptionally attractive teenage boy, it is basically law that I’m hormonal. So—” He looked at Tolly after snapping the laptop shut. “—if you’re not a runner, who are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Panicked eyes looked at Tolly across the table.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I… am Leigh’s bodyguard.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Is that, like, a euphemism?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("No")]), _vm._v(",” Leigh said. “Look, kid, I might be into some trouble, all right, so you need to steer clear for a while. No dropping by like this unannounced for a few days.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Wait, he really is your bodyguard?” Ralph looked appropriately troubled. “Is it Sweeney? Or the Morettis?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t stick your nose where it doesn’t belong,” Leigh said sharply, but even such an authoritative tone did not seem to affect the boy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’re kinda scrawny, no offense,” he told Tolly. “You sure you can protect him?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I will let no harm befall Leigh, I promise you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Cool. Weird, but… cool.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Bus. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("School")]), _vm._v(".” Leigh stood from his chair.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Going! Thanks, Hurley. Be safe, okay? You’re the only one I can talk to about girls without worrying you’ll steal the ones I like. Like Deanna. I am totally wearing her down. The other night—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Go")]), _vm._v(".” Leigh pushed him toward the door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m going! Keep it loose, Bodyguard Man!” he called, then gave a little salute before rushing out the door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly was all smiles when Leigh turned back to him. “You see. You are a good man.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What, charity work for that brat?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You helped a child in need with no benefit to yourself. A true scoundrel would never do that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Something chimed in the living room, and Leigh hurried to the coffee table to pick up his cell phone. That Tolly understood as something humans used to communicate long distance, which he thought very useful, but Leigh’s lips pursed tightly when he looked at the screen. “Alvin. He wants me to meet him at one of his father’s clubs.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I will go with you.” Tolly gathered his last bite of food to clear his plate.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hang on….” Leigh started to dissent but stopped, hand dragging down his face as he looked about his apartment, no doubt debating if he wanted to ask Tolly to stay.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I will go with you,” Tolly said again. “Merfolk are stronger than humans, even if I do appear… scrawny. I can protect you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Better than leaving you here to fend for yourself. Fine. I need to get changed first. Just put the dishes in the sink, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You have not finished eating.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh scratched back along his scalp, clearly antsy. Returning to the table but not sitting, he gathered his own last bite and shoved it into his mouth. He gestured at the plate in irritation before storming away to his bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly was annoying him. He had to be careful. He had to prove his worth to Leigh.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Once again, he did as he had been instructed, even rinsing the plates first to make them cleaner. He itched to peek into the bedroom while Leigh changed. He wanted to know what Leigh looked like bare, but given how he had reacted to seeing Tolly, he doubted he would appreciate having an audience.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("A minute later, Leigh returned in a more subdued combination of similar clothing to Tolly’s, put on his shoes, a jacket, and thrust like items at Tolly. Shoes were especially odd to walk in, but he could adjust. He did not want to cause Leigh any trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You are upset with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m sorry, I’m just…. My life is on the line, you got that?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes. I got that. I meant what I said to Ralph. I will not let any harm befall you.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Fine, whatever. Let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly stuck close to Leigh as they locked up the apartment and headed down the hallway, then farther down the stairs toward the front entrance. Leigh seemed to be in a great hurry, either to reach their destination faster or to escape the apartment building before any additional interruptions arose.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Unfortunately, they were not quite fast enough to reach the exit before two young ones flew out of their apartment almost directly into Leigh’s legs.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Whoa, Gar, Gert, slow down! Where’s your mother?” Leigh tried to collect them, but the youngest of the two, a girl about four or five, continued zipping about as what must be her seven- or eight-year-old brother chased her.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Gert!” the boy called. “You don’t always get to be the Jedi! It’s not fair!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Is too! I’m the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("girl")]), _vm._v("!” she shouted back, darting around Leigh’s legs at great speed, making it impossible for him to move. Unlike with Ralph, however, who was older, Leigh did not jump to frustration with these two, but stood still, patient and waiting for them to settle down.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“That doesn’t even mean anything! Girls aren’t always the good guys!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Hey")]), _vm._v(",” Leigh said louder but without raising his voice too harshly. “How can you play Sith and Jedi without lightsabers, huh? Maybe worry about that first.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We only have one and Gert broke it,” Gar said, stopping finally as he crossed his arms in a huff, while his sister clung to Leigh’s legs and stayed hidden behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Did not! The sword part wouldn’t come out. I was just helping.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sith and Jedi?” Tolly asked. “Like the movies?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The children seemed to notice Tolly for the first time, and while the boy looked at him warily, the little girl came out from behind Leigh’s legs. “Do you like "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Star Wars")]), _vm._v(", mister? Are you a friend of Mr. Hurley?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A new friend, yes.” Tolly crouched down to be closer to her level. “And I like those movies very much. Would it not be more fun to play the Sith? You could be ‘bad’ but be turned to the light side. That story is more interesting than starting as the hero, do you not agree?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Her big brown eyes blinked before she exclaimed, “I wanna be Sith! Gar can be the Jedi this time.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well…. Wait, I….” Her brother tried to backtrack as the Sith suddenly sounded more appealing, but Tolly laughed to discourage them from fighting further.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What else do you like to pretend?” he asked Gert.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Uhh… that I’m a Jedi or a princess or a dragon. Or a mermaid!” she added excitedly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly saw the way Leigh tensed, but he knew what humans thought of his kind. “The nice kind of merfolk, I hope?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why would a mermaid be mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly wondered that too. There were no nice merfolk outside of fairy tales other than himself. Maybe somewhere, but none that he had met. “Then you are a very nice mermaid, Miss Gert. Quite lovely, in fact. Your hair would look beautiful in the water. May I ask what color your tail is?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Umm… purple!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Royalty indeed,” he said. Not among his people, but it was a royal color, he had heard, and very pretty. It would look gorgeous on scales. “Perhaps you are a merfolk princess.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I can be both?” Gert lit up at the thought.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Of course. Was not Ariel both?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The little girl seemed enchanted now, and because of her reaction, Leigh seemed enchanted, too, which made Tolly feel as though he had succeeded in something.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Mermaids are boring,” Gar said firmly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And what if one were like a shark?” Tolly snapped his teeth to prove his point.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Mermaids aren’t like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Have you ever met one?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No, stupid.” The boy kept his arms crossed. “Mermaids aren’t real.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Garfield Sean Richardson, do we call people ‘stupid’?” A commanding voice came from the children’s apartment, preceding the appearance of a woman who was clearly their mother, with the same dark skin, hair, and eyes. She multitasked with ease while waiting for an answer, locking the door and juggling several bags.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No, Mama,” Gar said dutifully.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I didn’t think so. Oh! Who are…?” She startled at the sight of Tolly, who stood from his crouch to better greet her, but she relaxed when she saw Leigh there too. “He with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah, I’m keeping some extra muscle around for the next few days.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("He’s")]), _vm._v(" muscle?” She eyed Tolly with scrutiny.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Looks can be deceiving, apparently,” Leigh said. “We were heading out too.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Aww, but Mama”—Gert rushed to her mother’s side—“I wanna play mermaid.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Gertrude Ann, your brother needs to get to school, I need to get to work, and you need to get to Miss Maggie’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Miss Maggie looks after you?” Tolly asked the girl. “Well then, perhaps she will play make-believe.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Nah. She’s nice and all, but she can’t play much, coz her back hurts her sometimes.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Then perhaps later, when we have all returned, I can play with you instead.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Really?” She clung to her mother as she had Leigh but looked at Tolly with a sparkle in her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“If Leigh and I have the time, I would be honored.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Honored,” she repeated, like she only half understood the word. “Did you hear that, Mama?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I did indeed,” the woman said, still eyeing Tolly before speaking more quietly to Leigh. “Where’d you find this guy?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Long story, but you can trust him. This is Tolly. Tolly, this is Deanna, Gar, and Gert.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A pleasure.” Tolly bowed his head. “As are your children.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Watch ’em for a few hours and see if you still say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I would be delighted to.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The way her eyes widened made Tolly wonder if she had meant the comment as sarcasm. “I’m gonna hold you to that. See you later, Leigh. You let me know if I should be worried.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I will,” Leigh said. He let Gert hug his leg and gave a fist bump to Gar before the family hurried away.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Bye, Tolly!” Gert called to him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Goodbye, Miss Gert!” He waved but realized after a moment what the mother’s name had been. “That was Deanna, the one Ralph mentioned? But they are quite divergent in age.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He’s got a crush,” Leigh said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A crush?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“He "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("likes")]), _vm._v(" her, even though he doesn’t stand a chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“The father of her children is not with her?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No,” Leigh said with sudden coldness in his eyes, “and everyone’s better off that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I see. Perhaps, though, Ralph should focus on someone closer to his own age.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ve been trying to tell him that since he hit puberty. He’s a stubborn one.” Leigh began to move forward toward the exit, whereas the family had headed to Miss Maggie’s.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We all have difficulty giving up on the ones we want,” Tolly said, catching Leigh’s eye and making no attempt to veil what he meant. Leigh averted his eyes, but Tolly could feel that it was not disinterest that plagued him. “Children are lovely, though. Even my kin can have pleasant ones before they are trained to be cruel.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why aren’t you, then?” Leigh asked. “Cruel? If all the others are?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“My parents thought differently.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What happened to them?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“They were not fast enough swimmers.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh stopped just as he was about to push open the door, hand outstretched but hovering. He looked at Tolly in sympathy, but there was more that had him frozen. “I can’t believe I’m letting a mermaid come with me to see Arthur Sweeney.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I will not fail you, Leigh.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I know you won’t try to, but you need to follow my lead, got it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I will go wherever you tell me to.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No, I don’t just mean follow me, I mean…. If I say a lie about you or the situation, you need to go along with it as though it’s true. No one can know you’re a mermaid. Man. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Folk")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly appreciated that he was trying to use the right word. He was a kind man, no matter his profession or past deeds. Tolly just needed to convince him that they could trust each other. “I am braver than you believe, stronger than I seem, and smarter than you think.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Did you just paraphrase "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Winnie the Pooh")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Clearly, they were a proper match if Leigh knew that. “There are many outdoor movie showings near bodies of water. It is quite wonderful the way people sit together on blankets and enjoy stories told that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Star Wars. The Little Mermaid. Winnie the Pooh.")]), _vm._v("” Finally Leigh’s hand dropped from the door. “Tolly, does everything you know about humans come from movies?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Mostly.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Leigh’s eyes shone with fear again. “Great. This is going to go… great.” He pushed on the door at last, leaving Tolly to follow him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Tolly liked to think Leigh was right—things would go “great”—but unless he was mistaken, he was fairly certain that had been sarcasm too.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e7f9af3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0005.vue
// module id = 69
// module chunks = 0